import { Checkbox, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutSMC3Profile extends Layout {
    checkboxAllowUnsupported: Checkbox;
    checkboxAutoPro: Checkbox;
    checkboxEBol: Checkbox;
    checkboxPushTracking: Checkbox;
    checkboxServiceLevels: Checkbox;
    dataheaderSMC3Profile: DataHeader;
    labelRatingControlDefaults: Label;
    panelNoConfig: Panel;
    panelRatingControlDefaults: Panel;
    panelYesConfig: Panel;
    sourceSMC3ConfigProfile: DataSource;
    switchCarrierConfiguration: Switch;
    tabGeneral: Tab;
    tabsetProject44Profile: Tabset;
    textboxDescription: Textbox;
    textboxDocumentTypeDefault: Textbox;
    textboxId: Textbox;
    textboxPayerOverride: Textbox;
    textboxPayerTerms: Textbox;
    textboxPaymentTerms: Textbox;
    textboxPaymentTermsOverride: Textbox;
    textboxQuoteTimeout: Textbox;
    textboxRatingMode: Textbox;
    textboxScacsBatchSize: Textbox;
}
